import { strings } from '../strings';

/**
 * Returns a specific error message based on the type of browser data clearing failure.
 *
 * @param error - The error thrown during browser data clearing
 * @returns A user-friendly error message string
 */
export function getClearBrowserDataErrorMessage(error: unknown): string {
  if (error instanceof DOMException) {
    // Storage quota exceeded (localStorage/sessionStorage full)
    if (
      error.name === 'QuotaExceededError' ||
      error.name === 'NS_ERROR_DOM_QUOTA_REACHED'
    ) {
      return strings.clearBrowserData.storageQuota;
    }

    // Permission denied (SecurityError from storage or cache API)
    if (
      error.name === 'SecurityError' ||
      error.name === 'NotAllowedError' ||
      error.name === 'InvalidAccessError'
    ) {
      return strings.clearBrowserData.permission;
    }

    // IndexedDB-specific errors
    if (
      error.name === 'InvalidStateError' ||
      error.name === 'UnknownError' ||
      error.name === 'ConstraintError' ||
      error.name === 'DataError' ||
      error.name === 'TransactionInactiveError' ||
      error.name === 'ReadOnlyError' ||
      error.name === 'VersionError'
    ) {
      return strings.clearBrowserData.indexedDB;
    }
  }

  // Check for IndexedDB errors by message content as fallback
  if (error instanceof Error) {
    const message = error.message.toLowerCase();
    if (
      message.includes('indexeddb') ||
      message.includes('idb') ||
      message.includes('database')
    ) {
      return strings.clearBrowserData.indexedDB;
    }
    if (message.includes('quota') || message.includes('storage')) {
      return strings.clearBrowserData.storageQuota;
    }
    if (message.includes('permission') || message.includes('denied')) {
      return strings.clearBrowserData.permission;
    }
  }

  // Default fallback
  return strings.clearBrowserData.failed;
}
